import { render, staticRenderFns } from "./editWarning.vue?vue&type=template&id=298934b6&scoped=true&"
import script from "./editWarning.vue?vue&type=script&lang=js&"
export * from "./editWarning.vue?vue&type=script&lang=js&"
import style0 from "./editWarning.vue?vue&type=style&index=0&id=298934b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298934b6",
  null
  
)

export default component.exports